import React, { useContext, useEffect, useState } from "react";
import Header from "../../componentes/header/header";
import JsonContainer from "../../componentes/containerJson/ContainerJson";
import ImagemCurso from "./imgCapacitacao/imagem1.jpg";
import { Helmet } from "react-helmet";
import FinalComponent from "../../componentes/EndPage/Final";

import CursosData from "./cursos.json";
import CapacitacaoData1 from "./capacitacao1.json";
import translations from "./traducao.json";
import { LanguageContext } from "../../componentes/LanguageContext";

function Capacitacoes() {
  const { language } = useContext(LanguageContext);

  const [cursosData, setCursosData] = useState(
    CursosData[language] || CursosData["pt"]
  );
  const [translation, setTranslation] = useState(
    translations[language] || translations["pt"]
  );
  const [capacitacaoData1, setCapacitacaoData1] = useState(
    CapacitacaoData1[language] || CapacitacaoData1["pt"]
  );

  useEffect(() => {
    setCursosData(CursosData[language] || CursosData["pt"]);
    setCapacitacaoData1(CapacitacaoData1[language] || CapacitacaoData1["pt"]);
    setTranslation(translations[language] || translations["pt"]);
  }, [language]);

  return (
    <>
      <Helmet>
        <title>
          {translation?.capacitacoesTitle || "Capacitações"} | SOBREVIDAS-ACS
        </title>
      </Helmet>
      <Header />

      <div className="flex justify-center w-full">
        <h2
          className="
                        text-[30px] text-[#B040B1] font-black relative inline-block
                        mt-[0vh] mb-[6vh]
                        max-[1424px]:mt-[12vh] max-[1024px]:mt-[14vh] max-[768px]:mt-[18vh] max-[480px]:mt-[20vh]
                        text-center
                    "
        >
          {translation?.capacitacao || "Capacitação"}
          <span
            className="
                            absolute bottom-[-1px] left-[-55%] w-[200%] h-[45px]
                            bg-gradient-to-r from-[rgba(106,13,173,0.4)] to-[rgba(255,102,178,0.4)]
                            shadow-[5px_5px_10px_rgba(0,0,0,0.2)] -z-20 rounded-[50px]
                        "
            aria-hidden="true"
          />
        </h2>
      </div>

      <div className="relative mr-[15%] ml-[10%] mb-[5%] flex flex-wrap justify-center items-center">
        <div className="flex-1 m-[5%]">
          <img
            src={ImagemCurso}
            alt={translation?.imagemCursoAlt || "Imagem do curso"}
            className="w-full min-w-[300px] max-w-[500px] min-h-auto"
          />
        </div>
        <div className="flex-1 m-[1%] max-w-[800px]">
          <div class="text-left mb-5 bg-white p-8 md:p-10 border-l-[5px] border-l-[#6A0DAD] shadow-[5px_5px_10px_rgba(0,0,0,0.2)] rounded-[2vh] min-w-[300px]">
            <JsonContainer data={capacitacaoData1} />
          </div>
          <div class="text-left mb-5 bg-white p-8 md:p-10 border-l-[5px] border-l-[#6A0DAD] shadow-[5px_5px_10px_rgba(0,0,0,0.2)] rounded-[2vh] min-w-[300px]">
            <JsonContainer data={cursosData} />
          </div>
        </div>
      </div>

      <FinalComponent />
    </>
  );
}

export default Capacitacoes;
